import SenderReceiverDataTypeListItem from '../components/SenderReceiverDataTypeListItem'

export default class EndpointItem extends SenderReceiverDataTypeListItem {}
